import { createAsyncThunk } from '@reduxjs/toolkit'
import SystemRole from './system-role-model'
import {
  delete_systemRole,
  load_systemRoles,
  store_systemRole,
} from './systemRole-service'

export const LoadSystemRolesAsync = createAsyncThunk<any, any>(
  'composer/load/systemRole',
  async (params: { uid: string }) => {
    return await load_systemRoles(params)
  },
)

export const CreateSystemRoleAsync = createAsyncThunk<any, any>(
  'composer/create/systemRole',
  async (params: SystemRole) => {
    return await store_systemRole(params)
  },
)

export const DeleteSystemRoleAsync = createAsyncThunk<any, any>(
  'composer/delete/systemRole',
  async (params) => {
    return await delete_systemRole(params)
  },
)
